import { TagDesignTokens } from '@primeuix/themes/aura/tag';

export const tagTokens: TagDesignTokens = {
  root: {
    fontSize: '0.875rem',
    fontWeight: '700',
    padding: '0.25rem 0.5rem',
    gap: '0.25rem',
    borderRadius: '{border.radius.md}',
    roundedBorderRadius: '{border.radius.xl}',
  },
  icon: {
    size: '0.875rem',
  },
  colorScheme: {
    light: {
      primary: {
        background: '{primary.50}',
        color: '{primary.500}',
      },
      secondary: {
        background: '#F3F3F5',
        color: '{primary.950}',
      },
      success: {
        background: '{green.50}',
        color: '{green.600}',
      },
      info: {
        background: '{violet.50}',
        color: '{violet.500}',
      },
      warn: {
        background: '{orange.50}',
        color: '{orange.600}',
      },
      danger: {
        background: '{red.50}',
        color: '{red.600}',
      },
      contrast: {
        background: '{surface.950}',
        color: '{surface.0}',
      },
    },
    dark: {
      primary: {
        background: '{primary.900}',
        color: '{primary.300}',
      },
      secondary: {
        background: '#2C2953',
        color: '#EAEAEE',
      },
      success: {
        background: '{green.900}',
        color: '{green.300}',
      },
      info: {
        background: '{violet.900}',
        color: '{violet.200}',
      },
      warn: {
        background: '{orange.900}',
        color: '{orange.300}',
      },
      danger: {
        background: '{red.900}',
        color: '{red.300}',
      },
      contrast: {
        background: '#E7E7EC',
        color: '{primary.950}',
      },
    },
  },
  css: () => `
    .p-tag-icon {
      width: auto !important;
    }

    .p-tag-label {
      white-space: nowrap;
    }
  `,
};
